<template>
  <div class="popup">
    <div class="popup-bg"></div>
    <div class="content">
      <p class="tip">{{ tip }}</p>
      <button class="btn j-close-tip-sure" @click="close" :pointValue="tip">
        확인
      </button>
      <em class="close j-close-tip-close" @click="close" :pointValue="tip"></em>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tip'],
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
$termsImg: '~@assets/image/terms/';
.popup {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  &-bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .4);
  }
  .content {
    display: flex;
    position: absolute;
    left: 50%;
    top: 50%;
    flex-direction: column;
    align-items: center;
    padding-top: 67px;
    border-radius: 20px;
    width: 590px;
    background: #fff;
    transform: translate(-50%, -50%);
  }
  .tip {
    width: 456px;
    line-height: 40px;
    text-align: center;
    font-weight: bold;
    font-size: 34px;
    color: #414141;
  }
  .btn {
    margin: 43px auto;
    border-radius: 28px;
    width: 456px;
    height: 60px;
    background: #84b7ee;
    cursor: pointer;
    line-height: 60px;
    font-size: 30px;
    color: #fff;
  }
  .close {
    position: absolute;
    right: 21px;
    top: 21px;
    width: 24px;
    height: 24px;
    background: url($termsImg + 'close.png') no-repeat;
    background-size: contain;
    cursor: pointer;
  }
}
@media screen and (orientation: landscape) {
  .popup {
    .content {
      width: 396px;
      .tip {
        width: 456px;
        line-height: 40px;
        font-size: 14px;
      }
    }
    .btn {
      width: 356px;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
    }
    .close {
      right: 10px;
      top: 10px;
      width: 18px;
      height: 18px;
    }
  }
}

</style>
